module.exports = __webpack_public_path__ + "img/volorant.d91ecdaf.png";